import template from 'text!./medical-treatment.html';
import controller from './MedicalTreatmentCtrl';

export default {
    template,
    controller,
    bindings: {
        workersComp: '='
    }
};
